import React from "react";
import { useParams } from "react-router-dom";

import SchemaNav from "components/SchemaNav";
import PageContent from "components/PageContent";
import Panel from "components/Panel";

import Table from "./Table";
import { useQueryStringSearch } from "components/QueryStringSearch";

const SchemaViewList: React.FunctionComponent = () => {
  const { databaseId } = useParams();
  const [searchTerm, SearchInput] = useQueryStringSearch("q");

  return (
    <PageContent
      title="Schema Statistics"
      pageCategory="schema-views"
      pageName="index"
      featureNav={<SchemaNav databaseId={databaseId} />}
    >
      <Panel title="All Views" secondaryTitle={<SearchInput />}>
        <Table databaseId={databaseId} searchTerm={searchTerm} />
      </Panel>
    </PageContent>
  );
};

export default SchemaViewList;
